import Axios from "axios";
export class UrlServiceClient {
    constructor(config) {
        this.config = config;
    }
    async getUrl(urlId, locale) {
        const request = `${this.config.baseUrl}/url/${this.config.tenant}/${locale.replace("_", "-")}/${encodeURIComponent(urlId)}?requestor=${this.config.requestor}`;
        const response = await Axios.get(request);
        return response.data.url;
    }
    async getProductUrl(mpvProductId, locale) {
        return await this.getUrl(mpvProductId, locale);
    }
    async getTlpUrl(mpvProductId, locale) {
        return await this.getUrl(`TLP:${mpvProductId}`, locale);
    }
}
//# sourceMappingURL=UrlService.js.map